import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Message, List } from 'semantic-ui-react';
import { ModalTemplate, Loading, Button as Btn } from 'components';

import * as common from 'libs/commonFunc';

import classNames from 'classnames/bind';
import styles from './ServiceShareChangeService.css';
const cx = classNames.bind(styles);

class ServiceShareChangeService extends PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { onProgress, shareInfo, changeShareService, handleOnToggleAModal } = this.props;
    const { serviceNo, serviceName, serviceUserName, serviceUserEmail, regEpoch } = shareInfo;

    return (
      <ModalTemplate
        closeOnEscape={false}
        closeOnDimmerClick={false}
        className={cx('modal-admin tiny', 'common-content')}
        closeIcon
        onToggleModal={handleOnToggleAModal}
        visible
        header={
          <div>
            {defineMessages(formatMessage({ id: 'ServiceShareChangeService_1', defaultMessage: '이용 서비스 변경' }))}
          </div>
        }
        buttons={
          <div className={cx('inline-block')}>
            <Btn buttonColor="#bbbbbb" onClick={handleOnToggleAModal}>
              {defineMessages(formatMessage({ id: 'ServiceShareChangeService_2', defaultMessage: '닫 기' }))}
            </Btn>
            <Btn className={cx('brand-button')} loading={onProgress} disabled={onProgress} onClick={changeShareService}>
              {defineMessages(formatMessage({ id: 'ServiceShareChangeService_3', defaultMessage: '확 인' }))}
            </Btn>
          </div>
        }>
        <Loading
          active={onProgress}
          size="small"
          content={defineMessages(formatMessage({ id: 'ServiceShareChangeService_4', defaultMessage: '변경중...' }))}
        />
        <div className={cx('message-header')}>
          {defineMessages(
            formatMessage({
              id: 'ServiceShareChangeService_5',
              defaultMessage: '현재 이용중인 서비스를 다음 서비스 환경으로 변경합니다.'
            })
          )}
        </div>
        <Message className={cx('template-detail-box')}>
          <div className={cx('template-detail')}>
            {/* <div className={cx('template-detail-name')}>세부정보</div> */}
            <List bulleted className={cx('template-detail-list')}>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareChangeService_6', defaultMessage: '서비스No' }))}
                </div>
                {serviceNo}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareChangeService_7', defaultMessage: '서비스명' }))}
                </div>
                {serviceName}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareChangeService_8', defaultMessage: '가입자' }))}
                </div>
                {serviceUserName}
              </List.Item>
              <List.Item className={cx('template-detail-item')}>
                <div className={cx('template-detail-item-title')}>
                  {defineMessages(formatMessage({ id: 'ServiceShareChangeService_9', defaultMessage: '이메일' }))}
                </div>
                {serviceUserEmail}
              </List.Item>
            </List>
          </div>
        </Message>
      </ModalTemplate>
    );
  }
}

ServiceShareChangeService.propTypes = {
  //
};
ServiceShareChangeService.defaultProps = {
  //
};

export default injectIntl(ServiceShareChangeService);



// WEBPACK FOOTER //
// ./src/script/components/share/ServiceShareChangeService.js